export const toPromise = <T>(subject: any): Promise<T> =>
  new Promise<T>((resolve) => subject.subscribe(resolve));
